import React from 'react';
import { Flex, Spinner, FlexBlock } from '@wordpress/components';
import { Component } from '@wordpress/element';

import 'regenerator-runtime/runtime.js';
import CompositionItem from './CompositionItem';

class CompositionsList extends Component {
  constructor(props) {
    super(props);
    // console.log('CompositionsList CTR:', props.content);
    this.state = {
      compositions: [],
      dataAvailable: false,
    };
  }

  // shouldComponentUpdate(prevProps, prevState) {
  //   console.log('CompsList should update:', this.props.shouldRender);
  //   return this.props.shouldRender;
  // }

  async componentDidMount() {
    // console.log('CompositionsList didMount:', this.props.content);
    // this.forceUpdate();
  }
  async componentDidUpdate(prevProps, prevState) {
    // console.log('CompositionsList didUpdate:', this.props.content);
    // create compositions items
    // const items = Object.keys(userCompositions).map((x) => userCompositions[x]);
    // console.log('CompositionsList', items);
    // const innerHTML = items[0]?.post_content;
    // const doc = new DOMParser().parseFromString(innerHTML, "text/html");
    // console.log(
    // 	'Comp name',
    // 	doc.querySelectorAll('widgetic')[0].getAttribute('compositionid')
    // );
    // console.log(
    // 	'found block attributes 1st',
    // 	parseWithAttributeSchema(items[0].post_content, {
    // 		compId: {
    // 			type: 'string',
    // 			source: 'html',
    // 		},
    // 	})
    // );
    // set the compositions in state
    // this.setState({
    //   dataAvailable: true,
    //   compositions: this.props.content,
    // });
  }

  render() {
    return (
      <FlexBlock style={{ height: '100%' }}>
        <Flex>
          <h3>Published blocks</h3>
        </Flex>

        <FlexBlock
          className='comps-list'
          style={{
            height: 'calc(100% - 52px)',
          }}
          ref={(el) => {
            this.compsListEl = el;
          }}
        >
          <div
            className='comps-holder'
            style={{
              borderRight:
                !this.compsListEl ||
                (this.compsListEl &&
                  this.compsListEl.clientHeight >=
                    this.compsHolderEl.clientHeight)
                  ? 'none'
                  : '1px solid',
            }}
            ref={(el) => {
              this.compsHolderEl = el;
            }}
          >
            {
              this.props.content.map((item, index) => (
                <CompositionItem
                  wp={this.props.wp}
                  item={item}
                  key={index}
                  addCompToBlock={this.props.addCompToBlock}
                />
              ))
              // (<div style={{ margin: '5px' }}>No blocks found.</div>)
            }
          </div>
        </FlexBlock>
      </FlexBlock>
    );
  }
}

export default CompositionsList;
